import { DashboardSettingsFilters, TicketPriority } from "../../../__generated__/api";
import { Ticket } from "../../../pages/tickets-v3/TicketsV3";
import TicketItem from "../ticket-item";
import { FILTER_REGISTRY, Filter } from "./base";

export default class PriorityFilter extends Filter {
    public static shouldCreate(filter: DashboardSettingsFilters): boolean {
        return filter.priorities?.isNotEmpty ?? false;
    }

    private priorities: Set<string>;

    public constructor(filter: DashboardSettingsFilters) {
        super(filter);
        this.priorities = new Set(filter.priorities);
    }

    public shouldInclude(ticket: TicketItem): boolean {
        return this.priorities.has(ticket.priority);
    }

    public shouldIncludeTicket(ticket: Ticket): boolean {
        return this.priorities.has(ticket.priority);
    }
}

FILTER_REGISTRY.register(PriorityFilter);
